<!-- src/components/layout/Footer.vue -->
<template>
  <footer :class="['site-footer', { 'map-mode': isMapRoute }]">
    <div class="footer-inner container">
      <div class="left">
        <div class="project-name">CT-map</div>
      </div>

      <div class="center">
        <a class="contact" href="mailto:tomowebsolutions@yandex.ru">tomowebsolutions@yandex.ru</a> — +7(926) 524-78-56
      </div>

      <div class="right">
         <a href="/privacy">Политика конфиденциальности</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    isMapRoute() {
      return this.$route && (this.$route.name === 'map' || this.$route.path === '/map')
    }
  },
  mounted() {
    // установить/обновлять переменную при монтировании
    this.updateMapFooterVar()
    // отслеживаем смену маршрута
    this.$watch('$route', () => this.updateMapFooterVar())
    // и ресайз окна, чтобы корректно считать высоту футера
    window.addEventListener('resize', this.updateMapFooterVar)
  },
  beforeUnmount() {
    // убрать слушатель и переменную при размонтировании
    window.removeEventListener('resize', this.updateMapFooterVar)
    document.documentElement.style.removeProperty('--map-footer-space')
  },
  methods: {
    updateMapFooterVar() {
      this.$nextTick(() => {
        if (this.isMapRoute && this.$el) {
          // даём небольшой запас (отступ от карты) + 24px буфер
          const h = (this.$el.offsetHeight || 120) + 24
          document.documentElement.style.setProperty('--map-footer-space', `${h}px`)
        } else {
          // не на странице карты — удаляем переменную (вернётся дефолт)
          document.documentElement.style.removeProperty('--map-footer-space')
        }
      })
    }
  }
}
</script>

<style scoped>
.site-footer{
  position: static;
  z-index: 1100;
  background: transparent; /* прозрачный по умолчанию */
  padding: 14px 0;
  pointer-events: auto;
}

/* стиль футера когда он на странице карты (непрозрачная панель с тенью) */
.site-footer.map-mode {
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 20px;

  /* ключевые правки: используем box-sizing и фиксированную ширину через left/right */
  width: calc(100% - 48px);
  box-sizing: border-box;

  background: var(--hp-button-color, #F6F6F6);
  border-radius: 14px;
  padding: 12px 20px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  z-index: 1300;
  overflow: hidden;       /* не давать контенту вылезать */
  margin: 0;              /* убрать auto */
}

/* внутренний контейнер делаем растягивающимся и убираем max-width */
.site-footer.map-mode .footer-inner {
  max-width: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* внутренности футера — цвет текста */
.footer-inner{
  max-width:1500px;
  margin:0 auto;
  padding: 0 20px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  color: var(--footer-text-color, #757575);
  font-size:14px;
}

/* ссылка и название */
.footer-inner a { color: var(--footer-text-color, #757575); text-decoration:none }
.project-name { font-weight:700; color: var(--footer-text-color, #757575); }
</style>
